<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                   
                    <h2 >पे प्रोफ़ाइल </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="65">
                <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id="64">
                    
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/fiAnbtH16Kw?si=vaIlO3JntZcLPgVv"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                
                    <!--<div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/t4vkDWertB0"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>-->
                </div>
               

                    
                    <label for="" class="mt-2" >पे प्रोफाइल आपके भुगतान प्रबंधन केंद्र
                        के रूप में कार्य करता है। यह आपकी विशिष्ट आवश्यकताओं के लिए विविध समाधान
                        प्रदान करते हुए आपके संग्रह संचालन को सुव्यवस्थित और सरल बनाता है। PayG
                        हमेशा अपने व्यापारियों की सेवा करने के लिए तैयार है और हमारे मूल्यवान
                        व्यापारियों के लिए अत्यधिक सहजता और दक्षता सुनिश्चित करने के लिए समर्पित है,
                        एक सहज अनुभव को प्राथमिकता देता है जो आपके व्यवसाय संचालन को सशक्त बनाता है,
                        इसलिए PayG "पे प्रोफाइल" का महान विचार लेकर आया। पे प्रोफाइल निश्चित रूप से
                        हमारे सभी व्यापारियों को अपनी व्यक्तिगत और अनुकूलित "बिजनेस प्रोफाइल" बनाने
                        में मदद करेगी क्योंकि यह एक बिजनेस वेबपेज की तरह ही है। इस नई सुविधा के साथ,
                        आपके ग्राहक आपके व्यवसाय के बारे में तब अधिक जान पाएंगे जब आप उनके साथ अपना
                        भुगतान लिंक या क्यूआर कोड साझा करेंगे। यह आपके ग्राहकों के साथ सीधे संबंध की
                        तरह है क्योंकि वे आपकी प्रोफ़ाइल के माध्यम से आपके व्यवसाय को पूरी तरह से
                        जान सकते हैं। व्यापारियों को अपनी पे प्रोफ़ाइल में सभी प्रासंगिक व्यावसायिक
                        जानकारी प्रदान करनी होगी ताकि उनके ग्राहकों को उनके बारे में जानने की
                        सर्वोत्तम संभावना हो। पे प्रोफ़ाइल व्यापारियों द्वारा उनकी आवश्यकताओं के
                        अनुसार बनाई जा सकती है क्योंकि यह पूरी तरह से अनुकूलन योग्य और निःशुल्क है।
                        अनुपालन के कारण और अपने ग्राहकों के लाभ के लिए, व्यापारी के लिए फ़ोन नंबर और
                        ईमेल पते सहित अपने व्यवसाय के बारे में सभी आवश्यक जानकारी प्रदान करना
                        महत्वपूर्ण है, ताकि किसी समस्या की स्थिति में उनसे संपर्क किया जा सके। पे
                        प्रोफ़ाइल के बारे में सबसे महत्वपूर्ण बात "भुगतान फ़ॉर्म" है और यह पूरी तरह
                        से अनुकूलन योग्य भी है। व्यापारी चुन सकता है कि या तो राशि सभी के लिए तय है,
                        ग्राहक वह राशि चुन सकते हैं जो वे भुगतान करना चाहते हैं या एक कैटलॉग बना
                        सकते हैं। ग्राहकों से भुगतान स्वीकार करने के क्षेत्र में, व्यापारियों को
                        अक्सर दो अलग-अलग परिदृश्यों का सामना करना पड़ता है: जब ग्राहक उनसे परिचित
                        होते हैं, और जब वे नहीं होते हैं। इस चुनौती को पहचानते हुए, PayG ने 'स्मार्ट
                        कलेक्ट' और 'ईज़ी कलेक्ट' सुविधाओं के रूप में एक रणनीतिक समाधान पेश किया है।
                        नीचे सुविधाओं का विस्तृत विवरण दिया गया है: </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="66">
                     <h2 >स्मार्ट कलेक्ट </h2>
                    <label for="" class="mt-2" >जब ग्राहक ज्ञात हों और उनका विवरण
                        व्यापारियों के पास उपलब्ध हो तो इस सुविधा "स्मार्ट कलेक्ट" का उपयोग किया जा
                        सकता है। बेहतर समझ के लिए आइए अपने दैनिक जीवन से एक उदाहरण लें। उदाहरण के
                        लिए, आइए सरकार के बिजली विभाग पर विचार करें। वे एक विशिष्ट राज्य से बिजली
                        बिल एकत्र करने के लिए जिम्मेदार हैं। उस राज्य के सभी निवासियों की जानकारी
                        पहले से ही सरकारी रिकॉर्ड में संग्रहीत है। तो, वे बस PayG के भीतर एक
                        "स्मार्ट कलेक्शन प्रोफ़ाइल" का चयन और सेट अप कर सकते हैं। अब आगे, बिजली
                        विभाग के पास अपने "पे प्रोफाइल" में एक एक्सेल फ़ाइल अपलोड करके बल्क लिंक
                        बनाने के दो विकल्प हैं और सारा डेटा वहां से पुनर्प्राप्त हो जाता है और बनाए
                        गए लिंक के माध्यम से, ग्राहक अपने बिलों का भुगतान कर सकते हैं। दूसरा विकल्प
                        तब काम में आता है जब किसी स्थिति के कारण, कोई ग्राहक पीछे रह जाता है और उस
                        लिंक तक पहुंचने और बिल का भुगतान करने में असमर्थ होता है, इसलिए बिजली विभाग
                        एक सामान्य लिंक साझा कर सकता है और ग्राहक आईडी, पता आदि जैसे विवरण दर्ज
                        करके, ग्राहक बिल का भुगतान कर सकता है. साथ ही स्मार्ट कलेक्ट में, व्यापारी
                        को पता होगा कि ग्राहकों से कितना पैसा आएगा, इसलिए PayG व्यापारी के स्मार्ट
                        कलेक्ट डैशबोर्ड में एक पाई चार्ट का उपयोग करता है। </label>
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="67">
                  
                    <h2 >आसान संग्रह </h2>
                    <label for="" class="mt-2" >
                        यह वह सुविधा है जिसमें ग्राहक व्यापारियों के लिए अज्ञात होते हैं। उदाहरण के
                        लिए, जब हम किसी रेस्तरां में जाते हैं, तो हम रेस्तरां के मालिक/व्यापारी के
                        लिए अज्ञात होते हैं, और हमारे विवरण उन व्यापारियों के लिए अज्ञात होते हैं,
                        जिनके पास हम जाते हैं और भुगतान करते हैं, इस मामले में, ईज़ी कलेक्ट का उपयोग
                        व्यापारियों द्वारा एकल लिंक के रूप में किया जा सकता है। कई ग्राहकों द्वारा
                        उपयोग किया जा सकता है। इसके अलावा, दान के लिए ईज़ी कलेक्ट का उपयोग किया जाता
                        है क्योंकि व्यापारी राशि के साथ-साथ ग्राहकों से भी अनजान होता है। ईज़ी
                        कलेक्ट में, व्यापारी एक कैटलॉग भी बना सकते हैं, यदि उनके व्यवसाय में अलग-अलग
                        उत्पाद हैं और उन उत्पादों के लिए दर सूची अलग है। उदाहरण के लिए, यदि व्यापारी
                        के पास एक मनोरंजन पार्क है और उनके पार्क में अलग-अलग क्षेत्र हैं जैसे कि
                        बच्चों का क्षेत्र, वयस्क क्षेत्र और खाने का क्षेत्र, तो उनके लिए भुगतान
                        अलग-अलग है। इसलिए, व्यापारी "ईज़ी कलेक्ट" में एक कैटलॉग बना सकता है और एक
                        क्यूआर कोड उत्पन्न कर सकता है और जब ग्राहक क्यूआर कोड को स्कैन करते हैं, तो
                        वे विकल्प चुन सकते हैं या तो वे बच्चों के क्षेत्र, वयस्क क्षेत्र, खाने के
                        क्षेत्र के लिए भुगतान करना चाहते हैं। , या सभी के लिए. प्रोफ़ाइल बनाते समय
                        व्यापारियों द्वारा यहां भुगतान पहले से भरा जाता है।
                    </label>
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'5')"
                    (mouseout)="showpayment(false,'5')" id="68">
                   <h2 >पे प्रोफाइल विशेषताएं: </h2>
                    <label for="" class="" >निश्चित रूप से, यहां पे प्रोफाइल की कुछ
                        प्रमुख विशेषताएं और लाभ दिए गए हैं: </label>
                    <label for="" class="mt-4" ><b>वैयक्तिकृत व्यावसायिक प्रोफ़ाइल:</b>
                        पे प्रोफ़ाइल व्यापारियों को अपनी व्यक्तिगत और अनुकूलित व्यावसायिक प्रोफ़ाइल
                        बनाने में सक्षम बनाती है। यह महत्वपूर्ण व्यावसायिक जानकारी और पेशकशों को
                        प्रदर्शित करने के लिए एक मंच प्रदान करता है। </label>
                    <label for="" class="mt-4" ><b>उन्नत ग्राहक अंतर्दृष्टि:</b>पे
                        प्रोफाइल के माध्यम से अपने भुगतान लिंक या क्यूआर कोड को साझा करके, व्यापारी
                        ग्राहकों को उनके व्यवसाय के बारे में व्यापक जानकारी प्रदान कर सकते हैं।
                        ग्राहक व्यापारी की सेवाओं, उत्पादों, संपर्क जानकारी और बहुत कुछ के बारे में
                        अधिक जान सकते हैं।


                    </label>
                    <label for="" class="mt-4" ><b>सुव्यवस्थित भुगतान संग्रह </b> <br>

                        पे प्रोफाइल व्यापारियों और ग्राहकों दोनों के लिए उपयोगकर्ता के अनुकूल
                        इंटरफेस की पेशकश करके भुगतान संग्रह प्रक्रिया को सरल बनाता है। इस सुविधा से
                        बिक्री और ग्राहक संतुष्टि में वृद्धि हो सकती है। </label>
                    <label for="" class="mt-4" ><b>व्यावसायिक उपस्थिति </b> <br>

                        पे प्रोफाइल के माध्यम से बनाई गई व्यावसायिक प्रोफ़ाइल व्यापारी की भुगतान
                        संग्रह प्रक्रिया में एक पेशेवर स्पर्श जोड़ती है, जिससे व्यवसाय का विश्वास और
                        विश्वसनीयता बढ़ती है। </label>
                    <label for="" class="mt-4" ><b>विपणन और ब्रांडिंग </b> <br>व्यापारी
                        अपने ब्रांड, उत्पादों और सेवाओं को बढ़ावा देने के लिए मार्केटिंग टूल के रूप
                        में अपनी पे प्रोफाइल का लाभ उठा सकते हैं। यह ब्रांड एक्सपोज़र और ग्राहक
                        जुड़ाव के लिए एक अतिरिक्त अवसर प्रदान करता है। </label>
                    <label for="" class="mt-4" ><b>केंद्रीकृत भुगतान प्रबंधन </b> <br>

                        व्यापारी भुगतान संबंधी गतिविधियों का प्रबंधन कर सकते हैं, जिसमें लेनदेन पर
                        नज़र रखना, रिफंड जारी करना और भुगतान इतिहास देखना शामिल है, यह सब एक
                        केंद्रीकृत मंच से। </label>
                    <label for="" class="mt-4" ><b>सरल उपयोग </b> <br>पे प्रोफाइल
                        ग्राहकों के लिए भुगतान लिंक या क्यूआर कोड के माध्यम से सुलभ है, जिससे
                        ग्राहकों के लिए व्यावसायिक जानकारी तक पहुंचना और अपने पसंदीदा तरीकों का
                        उपयोग करके भुगतान करना सुविधाजनक हो जाता है।

                    </label>
                    <label for="" class="mt-4" ><b>अनुमापकता </b> <br>पे प्रोफाइल
                        व्यापारी के व्यवसाय की वृद्धि के साथ-साथ ग्राहकों और लेनदेन की बढ़ती संख्या
                        को समायोजित कर सकता है। </label>
                </div>
            </div>
        </div>
   </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    
                    <h5 >
                        विषयसूची :
                    </h5>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#64">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >पे जी की पे प्रोफ़ाइल क्या है? </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://www.youtube.com/embed/t4vkDWertB0" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="pdfHover"
                                    [ngClass]="{'video':colors=='5'}" (click)="color('5')"
                                    >
                                    पे जी की पे प्रोफ़ाइल क्या है? </span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://www.youtube.com/embed/FXIMek45_-s" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="pdfHover"
                                    [ngClass]="{'video':colors=='6'}" (click)="color('6')"
                                    >
                                    पे प्रोफाइल के साथ दान एकत्र करें </span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <!--<div class="col-md-12 mt-3">
                    <a href="#65">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                              
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >PayG की पे प्रोफ़ाइल क्या है? </span>
                            </div>
                        </div>
                    </a>
                </div>-->
                <div class="col-md-12 mt-3">
                    <a href="#66">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >
                                    स्मार्ट कलेक्ट </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#67">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                            
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >आसान संग्रहण </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#68">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                              
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >पे प्रोफ़ाइल की विशेषताएं </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/disputes']">    <button class="btn btn-color" (click)="menues('Disputes')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp; डिस्प्यूट्स
                </button></a>
            </div>
            <div class="col-md-4    ">
              
                <a [routerLink]="['/easy-collect']">  <button class="btn btn-color" (click)="menues('Easy Collect')" > ईजी
                    कलेक्ट

                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>

        </div>
    </div>
    </div>